import { render, staticRenderFns } from "./SectionTag.vue?vue&type=template&id=7f5cff15&scoped=true&"
import script from "./SectionTag.vue?vue&type=script&lang=js&"
export * from "./SectionTag.vue?vue&type=script&lang=js&"
import style0 from "./SectionTag.vue?vue&type=style&index=0&id=7f5cff15&prod&lang=sass&scoped=true&"
import style1 from "./SectionTag.vue?vue&type=style&index=1&id=7f5cff15&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5cff15",
  null
  
)

export default component.exports